module.exports = __webpack_public_path__ + "img/html5.7e67d449.svg";